// src/components/SnackbarCloseButton.jsx
//
// Default action appended to every notistack snackbar so users don't
// have to wait for autoclose or re-trigger events to clear an info
// toast. Wired in `SnackbarProvider`'s `action` prop in App.js.
//
// Snackbars that supply their own `action` (e.g. useUndoableAction,
// SwUpdatePrompt) always win — this default only applies to snacks
// that don't pass their own `action`.

import React from 'react';
import { IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useSnackbar } from 'notistack';

const SnackbarCloseButton = ({ snackbarKey }) => {
  const { closeSnackbar } = useSnackbar();
  return (
    <IconButton
      size="small"
      onClick={() => closeSnackbar(snackbarKey)}
      aria-label="Dismiss notification"
      sx={{ color: 'inherit' }}
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );
};

export default SnackbarCloseButton;
